import { render, staticRenderFns } from "./App.vue?vue&type=template&id=07865085"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
import style0 from "./App.vue?vue&type=style&index=0&id=07865085&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.bun/vue-loader@15.11.1+cf975d9100cf2460/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports